import { render, staticRenderFns } from "./search.vue?vue&type=template&id=4ae022e0&scoped=true&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=4ae022e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae022e0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WareView: require('/app/components/ware-view/index.vue').default})
